import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const getListBranchs = async ({ token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.SUCURSAL.LIST}`, extraHeaders: { token: token } });;
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default getListBranchs;